import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { BASKET_DETAILS_STATE_INITIAL_VALUE, BASKET_DETAILS_STORAGE_KEY } from '@whitbread-eos/api';
import { useLocalStorage, renderSanitizedHtml, useSemanticTypography } from '@whitbread-eos/utils';
import React from 'react';
import { formatCurrency, formatDataTestId, formatPrice } from '../../utils/formatters';
import PromoTag from '../PromoTag';
import SubPrice from '../SubPrice';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var paymentOptions = {
  PAY_NOW: 'PAY_NOW',
  PAY_ON_ARRIVAL: 'PAY_ON_ARRIVAL',
  RESERVE_WITHOUT_CARD: 'RESERVE_WITHOUT_CARD',
  ACCOUNT_COMPANY: 'ACCOUNT_COMPANY'
};
export default function TotalCost(_ref) {
  var totalCostAmount = _ref.totalCostAmount,
    currency = _ref.currency,
    language = _ref.language,
    donation = _ref.donation,
    selectedPaymentOption = _ref.selectedPaymentOption,
    t = _ref.t,
    isCCUI = _ref.isCCUI,
    taxesMessage = _ref.taxesMessage,
    promoActions = _ref.promoActions,
    cityTaxTotal = _ref.cityTaxTotal,
    isCityTaxBreakdownEnabled = _ref.isCityTaxBreakdownEnabled;
  var _useLocalStorage = useLocalStorage(BASKET_DETAILS_STORAGE_KEY, BASKET_DETAILS_STATE_INITIAL_VALUE),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 1),
    basketDetailsState = _useLocalStorage2[0];
  var getTypographyProps = useSemanticTypography();
  var baseDataTestId = 'TotalCostConfirm';
  var cityTaxStyles = {
    priceStyle: {
      fontWeight: '600'
    }
  };
  var roomPrice = {
    label: t('hoteldetails.rates.bundles.roomPrice'),
    price: totalCostAmount && cityTaxTotal ? totalCostAmount - cityTaxTotal : 0
  };
  var cityTax = {
    label: t('booking.cityTax.label'),
    price: cityTaxTotal || 0
  };
  var tooltipContent = {
    title: t('booking.cityTax.tooltip.title'),
    description: renderSanitizedHtml(t('booking.cityTax.tooltip.description'))
  };
  return _jsx(Box, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, 'container')
  }, totalCostWrapperStyle), {}, {
    sx: {
      '@media print': {
        display: 'none'
      }
    },
    children: _jsxs(Box, {
      p: "lg",
      children: [donation && _jsxs(_Fragment, {
        children: [_jsxs(Flex, _objectSpread(_objectSpread({}, totalCostDonationContainerStyle), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({}, donationTextStyle), {}, {
            "data-testid": formatDataTestId(baseDataTestId, 'donationLabel'),
            children: t('booking.confirmation.donationMessage')
          })), _jsx(Text, _objectSpread(_objectSpread({}, donationAmountStyle), {}, {
            "data-testid": formatDataTestId(baseDataTestId, 'donationAmount'),
            children: formatPrice(formatCurrency(currency), donation.computedPrice.toFixed(2), language)
          }))]
        })), _jsx(Divider, _objectSpread({}, donationDividerStyle))]
      }), isCityTaxBreakdownEnabled && !!cityTaxTotal && _jsxs(_Fragment, {
        children: [_jsx(Text, _objectSpread(_objectSpread({}, hotelDirectionsHeadingStyles), {}, {
          "data-testid": "paymentSummary-label",
          children: t('booking.confirmation.paymentSummary')
        })), _jsx(SubPrice, {
          currencyCode: currency,
          language: language,
          label: roomPrice.label,
          price: roomPrice.price,
          infoIcon: false,
          defaultLayout: true,
          cityTaxStyles: cityTaxStyles
        }), _jsx(SubPrice, {
          currencyCode: currency,
          language: language,
          label: cityTax.label,
          price: cityTax.price,
          infoIcon: true,
          defaultLayout: true,
          tooltipContent: tooltipContent,
          cityTaxStyles: cityTaxStyles
        }), _jsx(Divider, {
          my: "md"
        })]
      }), _jsxs(Flex, _objectSpread(_objectSpread({}, totalCostContainerStyle), {}, {
        children: [_jsxs(Flex, _objectSpread(_objectSpread({}, totalCostLabelStyle), {}, {
          direction: "column",
          children: [_jsx(Text, _objectSpread(_objectSpread({
            as: "b",
            "data-testid": formatDataTestId(baseDataTestId, 'label')
          }, getTypographyProps({}, totalCostLabelSemanticTypography)), {}, {
            children: "".concat(t('booking.confirmation.totalCost'), ":")
          })), _jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, 'paymentMessage')
          }, getTypographyProps({}, paymentMessageSemanticTypography)), {}, {
            children: t(renderPaymentConfirmationText(selectedPaymentOption, isCCUI))
          }))]
        })), _jsx(Flex, _objectSpread(_objectSpread({}, totalCostAmountStyle), {}, {
          children: _jsx(Text, _objectSpread(_objectSpread({
            "data-testid": formatDataTestId(baseDataTestId, 'amount')
          }, getTypographyProps({}, totalCostAmountSemanticTypography)), {}, {
            children: formatPrice(formatCurrency(currency), totalCostAmount === null || totalCostAmount === void 0 ? void 0 : totalCostAmount.toFixed(2), language)
          }))
        }))]
      })), (basketDetailsState === null || basketDetailsState === void 0 ? void 0 : basketDetailsState.rateTags) && (basketDetailsState === null || basketDetailsState === void 0 ? void 0 : basketDetailsState.rateTags.length) > 0 && _jsx(Flex, {
        "data-testid": "hdp_discountPromoTag",
        justifyContent: "end",
        marginTop: "-0.6rem",
        children: _jsx(PromoTag, {
          rateDiscountTags: basketDetailsState === null || basketDetailsState === void 0 ? void 0 : basketDetailsState.rateTags,
          customStyleName: "BookingSummaryCard",
          promoActions: promoActions
        })
      }), !!(taxesMessage !== null && taxesMessage !== void 0 && taxesMessage.length) && _jsx(Flex, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(baseDataTestId, 'includeCityTax-wrapper')
      }, infoTextStyle), {}, {
        children: _jsx(Text, {
          "data-testid": formatDataTestId(baseDataTestId, 'TaxesMessage'),
          children: taxesMessage
        })
      }))]
    })
  }));
  function renderPaymentConfirmationText(paymentOption) {
    var isCCUI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    switch (paymentOption) {
      case paymentOptions.PAY_NOW:
        return isCCUI ? 'ccui.booking.confirmation.paymentTaken' : 'booking.confirmation.paymentTaken';
      case paymentOptions.PAY_ON_ARRIVAL:
        return isCCUI ? 'ccui.booking.confirmation.reservedWithCard' : 'booking.confirmation.reservedWithCard';
      case paymentOptions.RESERVE_WITHOUT_CARD:
        return isCCUI ? 'ccui.booking.confirmation.reservedWithoutCard' : 'booking.confirmation.reservedWithoutCard';
      case paymentOptions.ACCOUNT_COMPANY:
        return 'ccui.booking.confirmation.accountToCompany';
      default:
        return paymentOption;
    }
  }
}
var totalCostWrapperStyle = {
  mb: '2xl',
  color: 'darkGrey1',
  backgroundColor: 'lightGrey5'
};
var totalCostDonationContainerStyle = {
  w: 'full',
  justifyContent: 'space-between',
  lineHeight: 'var(--chakra-lineHeights-3)'
};
var donationTextStyle = {
  as: 'b',
  fontSize: 'md',
  flex: {
    mobile: 1,
    md: 'unset'
  }
};
var donationAmountStyle = {
  as: 'b',
  fontSize: 'xl',
  flex: {
    mobile: 1,
    md: 'unset'
  },
  display: {
    mobile: 'flex',
    md: 'inherit'
  },
  justifyContent: {
    mobile: 'flex-end',
    md: 'unset'
  },
  alignItems: {
    mobile: 'flex-end',
    md: 'center'
  }
};
var donationDividerStyle = {
  my: 'md',
  border: '1px solid var(--chakra-colors-lightGrey1)'
};
var totalCostContainerStyle = {
  w: 'full',
  justifyContent: 'space-between',
  lineHeight: 'var(--chakra-lineHeights-3)'
};
var totalCostLabelStyle = {
  w: 'full',
  lineHeight: 'var(--chakra-lineHeights-3)',
  flex: {
    mobile: 1,
    md: 'unset'
  },
  maxW: {
    mobile: '7.5rem',
    sm: 'none',
    md: 'none'
  }
};
var totalCostAmountStyle = {
  as: 'b',
  fontSize: '3xxl',
  lineHeight: 'var(--chakra-lineHeights-5)',
  flex: {
    mobile: 1,
    md: 'unset'
  },
  justifyContent: {
    mobile: 'flex-end',
    md: 'inherit'
  },
  alignItems: {
    mobile: 'flex-end',
    md: 'center'
  }
};
var totalCostLabelSemanticTypography = {
  textStyle: 'body-l-emphasis'
};
var paymentMessageSemanticTypography = {
  textStyle: 'body-m-regular'
};
var totalCostAmountSemanticTypography = {
  textStyle: 'heading-m'
};
var infoTextStyle = {
  justifyContent: 'flex-end',
  fontWeight: 'medium',
  lineHeight: '2',
  color: 'darkGrey1',
  fontSize: 'sm'
};
var hotelDirectionsHeadingStyles = {
  fontWeight: 'semibold',
  fontSize: '2xl',
  lineHeight: '4',
  mb: 'lg'
};